import { LoginRequestInterface } from '@interface/auth/login.interface';

export const initialLoginForm: LoginRequestInterface = {
  email: '',
  password: '',
  remember: true,
};
